export default {
  props: ['loading']
};